import { axiosPrivate } from "../../../api/axios";

const base = (group, project) => `/oss/${encodeURIComponent(group)}/${encodeURIComponent(project)}/ai/jobs`;
export const listAiJobs = async (group, project, offset = 0) =>
  (await axiosPrivate.get(base(group, project), { params: { offset } })).data.data;
export const uploadAiFile = async (group, project, file) => {
  const form = new FormData();
  form.append("file", file);
  return (await axiosPrivate.post(base(group, project), form, { headers: { "Content-Type": "multipart/form-data" } })).data.data;
};
export const readAiJob = async (group, project, id) =>
  (await axiosPrivate.get(`${base(group, project)}/${id}`)).data.data;
export const readAiResult = async (group, project, id) =>
  (await axiosPrivate.get(`${base(group, project)}/${id}/result`)).data.data;
export const saveAiReview = async (group, project, id, version, result) =>
  (await axiosPrivate.put(`${base(group, project)}/${id}/review`, { expected_version: version, result })).data.data;
export const retryAiJob = async (group, project, id) =>
  (await axiosPrivate.post(`${base(group, project)}/${id}/retry`)).data.data;
export const readAiSource = async (group, project, id) =>
  (await axiosPrivate.get(`${base(group, project)}/${id}/source`, { responseType: "blob" })).data;
export const matchAiItems = async (group, project, items) =>
  (await axiosPrivate.post(`/oss/${encodeURIComponent(group)}/${encodeURIComponent(project)}/standards/items/match`, { items })).data.data;
export const readAiRegistrations = async (group, project, id) =>
  (await axiosPrivate.get(`${base(group, project)}/${id}/registrations`)).data.data;
export const registerAiOrder = async (group, project, id, version, draftIndex) =>
  (await axiosPrivate.post(`${base(group, project)}/${id}/register`, {
    expected_version: version, draft_index: draftIndex, confirmed: true,
  })).data.data;
